import React from "react";
import { PageCrumbProps } from "../types/PageCrumb";
import { useTranslation } from "react-i18next";
import "./PageCrumb.css";

export const PageCrumb = (props: PageCrumbProps) => {
    const { currentPageCrumb, pathCrumbs, trial } = props;

    const { t } = useTranslation("common");

    const separator = <span className="separator">&nbsp;/&nbsp;</span>;

    return (
        <div
            className="path-crumbs flex flex-column sm:flex-row justify-content-start"
            data-cy="path-crumbs"
        >
            {pathCrumbs.length > 0 &&
                pathCrumbs.map((subPage, index) => (
                    <span
                        key={`${subPage}-${index}`}
                        className="path-crumb crumb"
                    >
                        {subPage}
                        {separator}
                    </span>
                ))}
            {currentPageCrumb === t("appNavigation.psc") && trial ? (
                <span className="current-page-crumb crumb">
                    {currentPageCrumb}{" "}
                    <span className="crumb-trial">
                        {`${t("appNavigation.trial")}`}
                    </span>
                </span>
            ) : (
                <span className="current-page-crumb crumb">
                    {currentPageCrumb}
                </span>
            )}
        </div>
    );
};
